<script>
    import {Screenshot} from "./Screenshot";
    import GenericElementTile from "../../content/common/genericElementTile.vue";
    import VTooltipWrapper from "../../common/v-tooltip-wrapper.vue";

    export default {
        name: "screenshot-element",
        components: {VTooltipWrapper, GenericElementTile},
        props: {
            screenshotData: Screenshot
        },
        methods: {
            showScreenshot() {
                if (this.noScreenshot) return;

                EaseEventBus.fire('screenshotDialogShow', this.screenshotData);
            },
            handleInfoClick() {
                if (!this.screenshotData.detailId) return;
                window.location = '/system/client-detail/' + this.screenshotData.detailId;
            }
        },
        computed: {
            noScreenshot() {
                return this.screenshotData.screenshotPath.includes('no_screenshot_');
            },
            cursorIcon() {
                if (this.noScreenshot) return 'cursor-default';
                return 'cursor-pointer'
            }
        }
    }
</script>

<template>
    <div class="ma-2">
        <generic-element-tile
            :id="`media-info-${screenshotData.id}`"
            :title="screenshotData.clientName"
            :img="screenshotData"
            :src="screenshotData.screenshotPath"
            :height="'150px'"
            :titleClass="screenshotData.validity"
            :cursorIcon="cursorIcon"
            @click="showScreenshot"
            @infoClick="handleInfoClick"
        />
    </div>
</template>
